import { Td } from '../../summary/components/Td.js';
import { Tr } from '../../summary/components/Tr.js';
import { Typography } from '../../summary/components/Typography.js';
import { WebOnly } from '../../summary/components/WebOnly.js';
import { SummaryTableExtraCells } from './SummaryTableExtraCells.js';
import { COMPS_PER_TABLE } from './constants.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from './types.js';

export const SummaryTitleRow = ({
  summary,
  sequence,
  tableIdx,
}: {
  summary: Tkv2PairedCostSummaryInterfaceV2;
  sequence: string[];
  tableIdx: number;
}) => {
  return (
    <Tr backgroundColor="surface2">
      <Td border="0 !important" colSpan={2} width="28%">
        <Typography variant="h5">Subject</Typography>
        <WebOnly>
          <Typography variant="body2">{summary.subjectMetadata.address ?? ''}</Typography>
        </WebOnly>
      </Td>
      {sequence.map((compId, idx) => (
        <Td key={`${compId}-${idx}`} colSpan={2} width="24%" border="0 !important">
          <Typography variant="h5">{`Comp ${idx + 1 + tableIdx * COMPS_PER_TABLE}`}</Typography>
          <WebOnly>
            <Typography variant="body2">{summary.compMetadata[compId]?.address ?? ''}</Typography>
          </WebOnly>
        </Td>
      ))}
      <SummaryTableExtraCells count={COMPS_PER_TABLE - sequence.length} span={2} suppressBorder />
    </Tr>
  );
};
